import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'react-bootstrap-5';

export default function PropertyNoteCard({ note, onEdit }) {
  return (
    <Card className="bg-light">
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between">
          <strong>
            Edited {new Date(note.updated_at).toLocaleDateString('en-US')}
          </strong>
          <Button variant="secondary" onClick={onEdit}>
            Edit
          </Button>
        </div>
        <p className="my-0" style={{ whiteSpace: 'pre-line' }}>
          {note.body}
        </p>
      </Card.Body>
    </Card>
  );
}

PropertyNoteCard.propTypes = {
  note: PropTypes.shape({
    body: PropTypes.string,
    updated_at: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func,
};
